import { render } from "./readyUseParts.vue?vue&type=template&id=677afcdf&scoped=true&ts=true"
import script from "./readyUseParts.vue?vue&type=script&lang=ts"
export * from "./readyUseParts.vue?vue&type=script&lang=ts"

import "./readyUseParts.vue?vue&type=style&index=0&id=677afcdf&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677afcdf"]])

export default __exports__